export default __webpack_public_path__ + "static/media/SV.bb2a514c.svg";